import { render } from "./EdoDocumentTitleFlowCard.vue?vue&type=template&id=53f93d7a&scoped=true"
import script from "./EdoDocumentTitleFlowCard.vue?vue&type=script&lang=js"
export * from "./EdoDocumentTitleFlowCard.vue?vue&type=script&lang=js"

import "./EdoDocumentTitleFlowCard.vue?vue&type=style&index=0&id=53f93d7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f93d7a"]])

export default __exports__